import NewSlideshow from '../../classes/NewSlideshow';

export const initApartmentCard= () => {
	const sliders = document.querySelectorAll( 'section.apartment-card' );
	const btnPrint = document.querySelector( '.slider-navigation>button' );

	const floorActive = () => {
			const idFloor = document.querySelector('.floor-image')?.getAttribute('id');

			if (idFloor)
			{
				const floor = document.querySelector(`svg [id='${idFloor}']`);

				if ( !floor )
				{
					return;
				}

				floor.classList.add('active');
			}
	};

	floorActive();

	const deleteBg = () => {
		const svgBg = document.querySelector('svg[role="img"]>rect');
		if (svgBg) {
			svgBg.setAttribute('fill', '');
		}
	};

	deleteBg();

	if ( btnPrint ) {
		btnPrint.addEventListener('click', () => {
			window.print();
		} );
	}

	if ( !sliders.length )
	{
		return;
	}

  const btnBack = document.querySelector('.apartment-info>a');
  
  	if ( window.history.length > 2 ) {
	btnBack.addEventListener('click', () => {
		history.back();
	} )
	} else {
		btnBack.setAttribute( 'href', '/apartments/' )
	}



	if ( !sliders.length )
	{
		return;
	}

	Array.from( sliders ).forEach( ( it ) => {
		const sliderInstance = new NewSlideshow( {
			element: it,
			loop: false,
      		bookmarks: true,
			buttons: false,
		} );

		sliderInstance.init();
	} );
};
